module.exports = __webpack_public_path__ + "img/14-sdg-full@2x.15dc2a89.png";